import { msg } from '~/utils/validation';
import { z } from 'zod';

export const schema = z.object({
  name: z.string().min(1, { message: msg.required }),
  start: z.string().min(1, { message: msg.required }),
  end: z.string().min(1, { message: msg.required }),
});

export type Schema = z.infer<typeof schema>;
